/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * A carrier-scoped note, for the Timeline tab.
 * @export
 * @interface CarrierNoteSummary
 */
export interface CarrierNoteSummary {
  /**
   *
   * @type {string}
   * @memberof CarrierNoteSummary
   */
  carrierNoteId: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierNoteSummary
   */
  occurredAt: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CarrierNoteSummary
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof CarrierNoteSummary
   */
  body?: string | null;
  /**
   * Who wrote it --- for a backfilled note, the Linear comment's author, not the importer.
   * @type {string}
   * @memberof CarrierNoteSummary
   */
  author?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierNoteSummary
   */
  createdBy?: string | null;
}

/**
 * Check if a given object implements the CarrierNoteSummary interface.
 */
export function instanceOfCarrierNoteSummary(
  value: object,
): value is CarrierNoteSummary {
  if (!("carrierNoteId" in value) || value["carrierNoteId"] === undefined)
    return false;
  if (!("occurredAt" in value) || value["occurredAt"] === undefined)
    return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  return true;
}

export function CarrierNoteSummaryFromJSON(json: any): CarrierNoteSummary {
  return CarrierNoteSummaryFromJSONTyped(json, false);
}

export function CarrierNoteSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierNoteSummary {
  if (json == null) {
    return json;
  }
  return {
    carrierNoteId: json["carrierNoteId"],
    occurredAt: json["occurredAt"],
    title: json["title"],
    body: json["body"] == null ? undefined : json["body"],
    author: json["author"] == null ? undefined : json["author"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
  };
}

export function CarrierNoteSummaryToJSON(json: any): CarrierNoteSummary {
  return CarrierNoteSummaryToJSONTyped(json, false);
}

export function CarrierNoteSummaryToJSONTyped(
  value?: CarrierNoteSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierNoteId: value["carrierNoteId"],
    occurredAt: value["occurredAt"],
    title: value["title"],
    body: value["body"],
    author: value["author"],
    createdBy: value["createdBy"],
  };
}
